"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.web3_sha3 = exports.web3_clientVersion = void 0;
const web3_1 = __importDefault(require("web3"));
// import { notImplemented } from "./utils.js";
const web3_clientVersion = (params, ctx) => __awaiter(void 0, void 0, void 0, function* () {
    const _a = yield ctx.tronClient.post("/wallet/getnodeinfo", {}), { data } = _a, rest = __rest(_a, ["data"]);
    return data.configNodeInfo.codeVersion;
});
exports.web3_clientVersion = web3_clientVersion;
const web3_sha3 = ([data], ctx) => {
    // TODO: return tron node version?
    const hash = web3_1.default.utils.sha3(data);
    return hash;
};
exports.web3_sha3 = web3_sha3;
